import React from 'react'
import PropTypes from 'prop-types'
import FeatureWrapper from '../FeatureWrapper'
import FeatureTitle from '../FeatureTitle'
import FeatureItems from '../FeatureItems'
import { Select } from 'loyal-react'
import { withRouter } from 'react-router'

const getTypeColor = SkuByType => {
  const colors = []

  SkuByType.map(item => {
    if (item.COR) {
      const verify = colors.filter(x => x.COR === item.COR).length > 0

      if (!verify) {
        const current =
          SkuByType.filter(x => x.currentSku === true && x.COR === item.COR)
            .length > 0

        colors.push({ sku: item.sku, COR: item.COR, currentSku: current })
      }
    }
  })

  return colors
}

const getCorSelected = SkuByType => {
  return SkuByType.filter(x => x.currentSku === true)[0].COR
}
const getObjectSelected = SkuByType => {
  return SkuByType.filter(x => x.currentSku === true)[0]
}
const ColorFeature = ({ history: { push }, SkuByType }) => (
  <FeatureWrapper>
    <FeatureTitle>
      Escolha a cor: <strong>{getCorSelected(SkuByType)}</strong>
    </FeatureTitle>
    <FeatureItems>
      <Select
        id='colors'
        label='Cores'
        className='col-12 col-md-6'
        displayValue='COR'
        selectedValue='sku'
        options={getTypeColor(SkuByType)}
        value={getObjectSelected(SkuByType)}
        placeholder='Selecione'
        onChange={e => push(`/products/${e.sku}`)}
      />
    </FeatureItems>
  </FeatureWrapper>
)

ColorFeature.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  SkuByType: PropTypes.array
}

export default withRouter(ColorFeature)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/ColorFeature.js